import { Tag, TagGroup, TagList } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import type { MetricGroupKind } from '../MetricKind';
import type MetricKind from '../MetricKind';
import { getMetricKindDisplay } from '../MetricKind';

type MetricLabelProps = {
  kind: MetricKind | MetricGroupKind;
  isNumeric?: boolean;
  unitAggregationType?: 'sum' | 'average' | 'count_distinct';
  className?: string;
};

export const MetricLabel = ({ kind, isNumeric, unitAggregationType, className }: MetricLabelProps) => {
  const display = getMetricKindDisplay(kind, unitAggregationType, isNumeric);

  return (
    <TagGroup aria-label={display.displayName} className={className}>
      <TagList>
        <Tag size="small" textValue={display.displayName}>
          {'displayIcon' in display && <Icon name={display.displayIcon} size="tiny" />}
          {display.displayName}
        </Tag>
      </TagList>
    </TagGroup>
  );
};
